/** Keep customization image previews inside the card and viewport. */
function positionPreview(event) {
  if (!(event.target instanceof Element)) return;
  const choice = event.target.closest('.product-details [data-patchstitch-panel] .ps-choice');
  if (!choice) return;
  const popup = choice.querySelector('.ps-choice__popup');
  if (!(popup instanceof HTMLElement)) return;
  const card = choice.closest('.group-block');
  const choiceBounds = choice.getBoundingClientRect();
  const cardBounds = card?.getBoundingClientRect();
  const width = popup.getBoundingClientRect().width || Number.parseFloat(getComputedStyle(popup).width);
  if (!Number.isFinite(width) || width <= 0) return;
  const viewportWidth = document.documentElement.clientWidth;
  const minLeft = Math.max(16, (cardBounds?.left ?? 0) + 8);
  const maxRight = Math.min(viewportWidth - 16, (cardBounds?.right ?? viewportWidth) - 8);
  const centeredLeft = choiceBounds.left + choiceBounds.width / 2 - width / 2;
  const left = Math.max(minLeft, Math.min(centeredLeft, maxRight - width));
  popup.style.setProperty('--cp-preview-shift', `${left - centeredLeft}px`);
}

document.addEventListener('pointerover', positionPreview);
document.addEventListener('pointerdown', positionPreview);
document.addEventListener('focusin', positionPreview);
window.addEventListener('resize', () => {
  const choice = document.querySelector(
    '.product-details .ps-choice:is(.is-active, :hover), .product-details .ps-choice:focus-within'
  );
  if (choice) positionPreview({ target: choice });
});

/**
 * On touch, PatchStitch opens the tapped choice's preview (`.is-active`) by rebuilding the whole
 * option tree, which drops the shift set on pointerdown. Re-place it after each rebuild.
 */
const previewObserver = new MutationObserver(() => {
  const choice = document.querySelector('.product-details [data-patchstitch-panel] .ps-choice.is-active');
  if (choice) positionPreview({ target: choice });
});
for (const details of document.querySelectorAll('.product-details')) {
  previewObserver.observe(details, { childList: true, subtree: true });
}

/**
 * iOS fires no click for a tap on non-interactive content, so PatchStitch's document click
 * listener never closes an open tap preview there. Send that click when the tap produced none.
 */
let pendingTapClick;
let touchStart;
document.addEventListener('pointerdown', (event) => {
  clearTimeout(pendingTapClick);
  touchStart = event.pointerType === 'touch'
    ? { id: event.pointerId, x: event.clientX, y: event.clientY }
    : undefined;
}, { passive: true });
document.addEventListener('pointermove', (event) => {
  if (touchStart?.id === event.pointerId &&
      Math.hypot(event.clientX - touchStart.x, event.clientY - touchStart.y) > 10) touchStart = undefined;
}, { passive: true });
document.addEventListener('pointercancel', () => { touchStart = undefined; });
document.addEventListener('pointerup', (event) => {
  const tap = touchStart;
  touchStart = undefined;
  if (!tap || tap.id !== event.pointerId ||
      Math.hypot(event.clientX - tap.x, event.clientY - tap.y) > 10) return;
  if (event.pointerType !== 'touch' || !(event.target instanceof Element)) return;
  if (event.target.closest('.ps-choice') || !document.querySelector('.ps-choice.is-active')) return;
  clearTimeout(pendingTapClick);
  pendingTapClick = setTimeout(() => {
    if (document.querySelector('.ps-upload__dropzone.is-busy')) return;
    // Target body, not document: Shopify's privacy-banner.js click listener calls target.closest().
    document.body.dispatchEvent(new MouseEvent('click', { bubbles: true }));
  }, 400);
});
document.addEventListener('click', () => clearTimeout(pendingTapClick), true);
window.addEventListener('scroll', () => clearTimeout(pendingTapClick), { passive: true, capture: true });
